// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useCallback } from 'react'
import './radioButtonsGroup.scss'
import classNames from 'classnames'
import RadioButton from '../radio-button/RadioButton'

const RadioButtonsGroup = memo(
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  ({ optionsList, setSelectedOption, className, onChangeButtonGroup, useCustomLogic = false }) => {
    const onToggleSelectMode = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (value) => {
        if (useCustomLogic) {
          // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
          setSelectedOption((prevOptions) =>
            // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
            prevOptions.map((option) => ({
              ...option,
              isChecked: option.value === value,
            })),
          )
        } else {
          // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
          setSelectedOption((prev) => prev.map((t) => ({ ...t, isChecked: t.value === value })))
        }
        onChangeButtonGroup?.()
      },
      [onChangeButtonGroup, setSelectedOption],
    )

    return (
      <div className={classNames('radio-buttons-group-container', className)}>
        {/*
         // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered */}
        {optionsList.map(({ value, isHidden, isChecked }) => (
          <RadioButton
            key={value}
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            isHidden={isHidden}
            useCustomLogic={useCustomLogic}
            onToggleSelectMode={useCustomLogic ? () => onToggleSelectMode(value) : onToggleSelectMode}
            isChecked={isChecked}
            value={value}
          />
        ))}
      </div>
    )
  },
)

export default RadioButtonsGroup
